// extracted by mini-css-extract-plugin
export default {"root":"Categories_root__AWCYw","subTitle":"Categories_subTitle__bncJT","title":"Categories_title__o40B4","categories":"Categories_categories__yPubr"};